"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniq = exports.recursivePartialOverride = void 0;
function recursivePartialOverride(x, y) {
    if (y === undefined || y === null)
        return x;
    const objProto = Object.getPrototypeOf({});
    if (Object.getPrototypeOf(y) != objProto)
        return y;
    let v = Object.assign({}, x);
    let yKeys = Object.keys(y);
    const allKeys = uniq(Object.keys(v).concat(yKeys));
    for (const key of allKeys) {
        if (yKeys.indexOf(key) >= 0) {
            const itemKeyVal = y[key];
            if (null != itemKeyVal && typeof itemKeyVal === "object") {
                const baseKeyVal = v[key];
                v[key] = recursivePartialOverride(baseKeyVal, itemKeyVal);
            }
            else {
                v[key] = itemKeyVal;
            }
        }
    }
    return v;
}
exports.recursivePartialOverride = recursivePartialOverride;
function uniq(ts) {
    const out = [];
    for (const v of ts) {
        if (out.indexOf(v) < 0) {
            out.push(v);
        }
    }
    return out;
}
exports.uniq = uniq;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3NoYXJlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFNQSxTQUFnQix3QkFBd0IsQ0FBSSxDQUFJLEVBQUUsQ0FBZ0I7SUFDaEUsSUFBSSxDQUFDLEtBQUssU0FBUyxJQUFJLENBQUMsS0FBSyxJQUFJO1FBQUUsT0FBTyxDQUFDLENBQUM7SUFDNUMsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLGNBQWMsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUMzQyxJQUFJLE1BQU0sQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLElBQUksUUFBUTtRQUFFLE9BQU8sQ0FBUSxDQUFDO0lBQzFELElBQUksQ0FBQyxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO0lBQzdCLElBQUksS0FBSyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDM0IsTUFBTSxPQUFPLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7SUFDbkQsS0FBSyxNQUFNLEdBQUcsSUFBSSxPQUFPLEVBQUU7UUFDekIsSUFBSSxLQUFLLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUMzQixNQUFNLFVBQVUsR0FBSSxDQUFTLENBQUMsR0FBRyxDQUFDLENBQUM7WUFDbkMsSUFBSSxJQUFJLElBQUksVUFBVSxJQUFJLE9BQU8sVUFBVSxLQUFLLFFBQVEsRUFBRTtnQkFDeEQsTUFBTSxVQUFVLEdBQUksQ0FBUyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2dCQUNsQyxDQUFTLENBQUMsR0FBRyxDQUFDLEdBQUcsd0JBQXdCLENBQUMsVUFBVSxFQUFFLFVBQVUsQ0FBQyxDQUFDO2FBQ3BFO2lCQUFNO2dCQUNKLENBQVMsQ0FBQyxHQUFHLENBQUMsR0FBRyxVQUFVLENBQUM7YUFDOUI7U0FDRjtLQUNGO0lBQ0QsT0FBTyxDQUFDLENBQUM7QUFDWCxDQUFDO0FBbkJELDREQW1CQztBQUVELFNBQWdCLElBQUksQ0FBSSxFQUFZO0lBQ2xDLE1BQU0sR0FBRyxHQUFRLEVBQUUsQ0FBQztJQUNwQixLQUFLLE1BQU0sQ0FBQyxJQUFJLEVBQUUsRUFBRTtRQUNsQixJQUFJLEdBQUcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxFQUFFO1lBQ3RCLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDYjtLQUNGO0lBQ0QsT0FBTyxHQUFHLENBQUM7QUFDYixDQUFDO0FBUkQsb0JBUUMifQ==